import { PortableText } from '@portabletext/react';
import { portableTextComponents } from '@/lib/sanity/portableTextComponents';
import type { MultiPlatformBlockContent } from '@/types/sanity/content';
import clsx from 'clsx';

interface MultiPlatformTextProps {
  content: MultiPlatformBlockContent | null | undefined;
  className?: string;
}

export default function MultiPlatformText({ content, className }: MultiPlatformTextProps) {
  if (!content || !content.desktop) {
    return null;
  }

  // Check if we have mobile-specific content
  const hasMobileContent = content?.showDifferentContentOnMobile && content?.mobile;

  return (
    <div>
      {hasMobileContent && (
        <div className={clsx('block tablet:hidden', className)}>
          <PortableText components={portableTextComponents} value={content.mobile!} />
        </div>
      )}
      <div className={clsx(hasMobileContent && 'hidden tablet:block', className)}>
        <PortableText components={portableTextComponents} value={content.desktop} />
      </div>
    </div>
  );
}
